import { Box, SuccessHiFive } from '@npco/zeller-design-system'

export const SuccessHiFiveIllustration = () => (
  <Box mb="24px">
    <SuccessHiFive size="medium" />
  </Box>
)
